import { useQuery } from "@tanstack/react-query";
import type { FundingApplicationSchemas } from "api-types";
import { axiosClient } from "auth-sdk";

export const FUNDING_APPLICATION_REVIEW_STATUS_API = "/api/:customerSlug/funding/api/review/status";
export const SUBSEQUENT_FUNDING_DATA_PULL_PROGRESS_KEY = "sf-dp-progress-:productRequestId";
export const SUBSEQUENT_FUNDING_DATA_PULL_PROGRESS_WINDOW_SECONDS = 60;

export interface FundingApplicationReviewDetailsElapsedTime
  extends FundingApplicationSchemas.FundingApplicationReviewDetails {
  elapsedTime: string | null;
  elapsedSeconds: number | null;
}

const getInReviewStepStatusQueryOptions = (customerDomain: string) => {
  const url = FUNDING_APPLICATION_REVIEW_STATUS_API.replace(":customerSlug", customerDomain);
  return {
    queryKey: [url],
    queryFn: () => axiosClient.get<FundingApplicationSchemas.FundingApplicationReviewState>(url),
    select: ({ data }): FundingApplicationSchemas.FundingApplicationReviewState => data,
    refetchOnMount: true,
    refetchInterval: 10000,
  };
};

export const useInReviewStepStatus = (customerDomain: string) =>
  useQuery(getInReviewStepStatusQueryOptions(customerDomain));
